/**
 * @sw-package inventory
 */
const PluginManager = window.PluginManager;

PluginManager.register(
    'ShowMoreButton',
    () => import('./plugin/show-more-button/show-more-button.plugin'),
    '[data-show-more-button]',
);

PluginManager.register(
    'BundleAccessibility',
    () => import('./plugin/bundle-accessibility/bundle-accessibility.plugin'),
    '[data-bundle-accessibility]',
);
